import { last } from "lodash";
import { PartnerFeeFormula, PartnerFeeFormulaStrategy, PartnerFeeFormulaType, Seller } from "types";
import { SubscriptionPackageType } from "types/src/types/SubscriptionPlan";
import { getSeller } from "../utils/getSeller";

export const isFlexLevelPaidByTraveler = (seller: Seller): boolean => {
    return !isFixedStrategy(seller.partnerFeeFormulas) && !isFeePaidBySeller(seller.partnerFeeFormulas);
};

export const isFixedStrategy = (partnerFeeFormulas: PartnerFeeFormula[]) => {
    if (partnerFeeFormulas?.length === 0) {
        return false;
    }

    return partnerFeeFormulas[0].strategy === PartnerFeeFormulaStrategy.FIXED;
};

export const isFeePaidBySeller = (partnerFeeFormulas: PartnerFeeFormula[]) => {
    if (partnerFeeFormulas?.length === 0) {
        return false;
    }

    const [formula] = partnerFeeFormulas;
    return formula?.type === PartnerFeeFormulaType.SELLER;
};

export const isAmountIncludesPartnerFee = (partnerFeeFormulas: PartnerFeeFormula[]) => {
    const partnerFeeFormula: PartnerFeeFormula | undefined = last(partnerFeeFormulas);
    return partnerFeeFormula?.orderAmountIncludesPartnerFee;
};

export const isPaidBySeller = (partnerFeeFormulas: PartnerFeeFormula[]) => {
    const partnerFeeFormula: PartnerFeeFormula | undefined = last(partnerFeeFormulas);
    return partnerFeeFormula?.type === PartnerFeeFormulaType.SELLER;
};

export const isPaidByTraveler = (partnerFeeFormulas: PartnerFeeFormula[]) => {
    const partnerFeeFormula: PartnerFeeFormula | undefined = last(partnerFeeFormulas);
    return partnerFeeFormula?.type === PartnerFeeFormulaType.TRAVELER;
};

export const isOnFlexSubscription = (seller: Seller) => {
    if (!seller.subscriptionPlan?.package?.type) {
        return false;
    }

    const { type } = seller.subscriptionPlan.package;
    return type === SubscriptionPackageType.FLEX_STANDARD || type === SubscriptionPackageType.FLEX_LEVEL;
};

export const showPartnerFee = () => {
    const seller = getSeller();
    if (seller.subscriptionPlan && !isOnFlexSubscription(seller)) {
        return false;
    }

    if (isPaidByTraveler(seller.partnerFeeFormulas) && isAmountIncludesPartnerFee(seller.partnerFeeFormulas)) {
        return true;
    }

    return isPaidBySeller(seller.partnerFeeFormulas);
};

export const showFlexStandardServiceFeeToSeller = (seller: Seller) => {
    const { partnerFeeFormulas = [] } = seller;
    const { showConvenienceFeeToSeller } = partnerFeeFormulas[0];

    return showConvenienceFeeToSeller;
};
